import React from 'react';

import { Alert, AlertTitle, Box, Typography } from '@mui/material';

export default function AnalyticsExplainerAlert() {
  return (
    <Alert severity="info" sx={{ mt: 2 }}>
      <AlertTitle>How to read these numbers</AlertTitle>
      <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 3 }}>
        <Typography component="li" variant="body2">
          <strong>Scope:</strong> Search-bar hotel searches in the selected range.
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Normalisation:</strong> Accents removed (&ldquo;é&rdquo; &rarr; &ldquo;e&rdquo;), lowercased, the
          words &ldquo;and&rdquo;/&ldquo;the&rdquo; removed, then every space, punctuation mark, and special character
          removed (not replaced). &ldquo;St. Kilda &amp; The Sea&rdquo; &rarr; &ldquo;stkildasea&rdquo;.
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Exact geo or vendor matches:</strong> exact match a normalised place name, hotel vendor/chain name, or
          special mode (&ldquo;anywhere&rdquo;, &ldquo;map area&rdquo;). Prefix matches do not count.
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Remaining searches:</strong> Everything else, including empty queries. All searches = exact matches +
          remaining.
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Grouping:</strong> Searches that have the exact same query. &ldquo;Bali&rdquo; and &ldquo;bali&rdquo;
          are separate rows.
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Sections:</strong>
          <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 2.5 }}>
            <Typography component="li" variant="body2">
              <strong>NLS searches</strong> — no prefix match, not a suggestion
            </Typography>
            <Typography component="li" variant="body2">
              <strong>Place/Property searches</strong> — query prefix-matched a place or property name
            </Typography>
            <Typography component="li" variant="body2">
              <strong>NLS suggestions</strong> — queries starting with a configured prefix or ending with a configured
              suffix; these take precedence over prefix matches
            </Typography>
          </Box>
        </Typography>
        <Typography component="li" variant="body2">
          <strong>Extracted values:</strong> Destination, landmark, and property IDs that HAVE been extracted.
        </Typography>
      </Box>
    </Alert>
  );
}
